// common
const common = {
  'common.Cancel': 'Cancel',
  'common.Save': 'Save',
  'common.add': 'Add',
  'common.operation': 'Operation',
  'common.modify': 'Modify',
  'common.Edit': 'Edit',
  'common.view': 'View',
  'common.delete': 'Delete',
  'common.sureDelete': 'Are you sure to delete',
  'common.deleteSuccess': 'Delete success',
  'common.addSuccess': 'Add success',
  'common.modifySuccess': 'Modify success',
  'common.ok': 'OK',
  'common.cancel': 'Cancel',
  'common.prompt': 'Prompt',
  'common.advSearch': 'Advanced Search'
};

// HomeBody
const HomeBody = {
  'HomeBody.Taskbar': 'Taskbar',
  'HomeBody.Bench': 'Bench',
  'HomeBody.reminder': 'reminder',
  'HomeBody.noData': 'No reminder data'
};

// Login
const Login = {
  'Login.NormalLogin': 'Normal Login',
  'Login.DomainLogin': 'Domain Login',
  'Login.UsernamePlaceholder': 'Username',
  'Login.PassworkPlaceholder': 'Password',
  'Login.Login': 'Login',
  'Login.userNameTip': 'Enter the username',
  'Login.passwordTip': 'Enter the password'
};

// RightBtns
const RightBtns = {
  'RightBtns.Report': 'Report',
  'RightBtns.LockScreen': 'Lock Screen',
  'RightBtns.Settings': 'Settings',
  'RightBtns.Logoff': 'Logoff',
  'RightBtns.ChangePassword': 'ChangePassword',
  'RightBtns.ClearCache': 'ClearCache',
  'RightBtns.ChangeThemeColor': 'Change Theme Color',
  'RightBtns.SelectThemeColor': 'Select Theme Color',
  'RightBtns.ChangeLanguage': 'Change Language/更换语言',
  'RightBtns.SelectLanguage': 'Select Language/选择语言',
  'RightBtns.About': 'About',
  'RightBtns.OK': 'OK',
  'RightBtns.success': 'success',
  'RightBtns.sureLock': 'Are you sure to lock the screen?',
  'RightBtns.sureLogoff': 'Are you sure to Logoff?',
  'RightBtns.Version': 'Version:',
  'RightBtns.VersionUpdate': 'Instruction of Version update',
  'RightBtns.ChangePassword': 'Change Password',
  'RightBtns.OriginalPassword': 'Original Password',
  'RightBtns.NewPassword': 'New Password',
  'RightBtns.Submit': 'Submit',
  'RightBtns.OriginalPasswordTip': 'Enter the original password',
  'RightBtns.NewPasswordTip': 'Enter the new password',
  'RightBtns.NewPasswordAgainTip': 'Enter the new password again'
};

// PersonCenter
const PersonCenter = {
  'PersonCenter.title': 'Person Center'
};

// Setting
const Setting = {
  'Setting.leftTitle': 'Necessary Functionality',
  'Setting.rightTitle': 'Optional Functionality'
};

// TableData
const TableData = {
  'TableData.pleaseSelectARecord': 'Please select a record'
};

// OrgChartData
const OrgChartData = {
  'OrgChartData.setting': 'Setting',
  'OrgChartData.saveStructure': 'Save Structure',
  'OrgChartData.up': 'Up',
  'OrgChartData.down': 'Down',
  'OrgChartData.sureSaveSturcture': 'Are you sure to save structure?'
};

export default {
  ...common,
  ...HomeBody,
  ...Login,
  ...RightBtns,
  ...PersonCenter,
  ...Setting,
  ...TableData,
  ...OrgChartData,
  add: 'add',
  edit: 'edit',
  cancel: 'cancel',
  save: 'save',
  view: 'view',
  delete: 'delete',
  choose: 'choose',
  modify: 'modify'
};
